import React, { PureComponent } from 'react';
import { SaveButton, Toolbar, DeleteButton } from 'react-admin';
import DeleteAlertDialog from '../../../components/DeleteAlertDialog/DeleteAlertDialog';
import RemoveButton from '../../../components/RemoveButton/RemoveButton';

class ToolBarEditProgram extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  deleteExercise = () => {
    this.setState({ isOpen: true });
  };

  handleCloseModalDelete = () => {
    this.setState({ isOpen: false, record: null });
  };

  render() {
    // eslint-disable-next-line no-unused-vars
    const { deleteExercise, ...props } = this.props;
    return (
      <>
        <Toolbar
          {...props}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            background: 'none',
          }}
        >
          <SaveButton {...props} label="save" submitOnEnter={false} />
          <RemoveButton variant="contained" deleteExercise={this.deleteExercise} />
        </Toolbar>
        <DeleteAlertDialog
          title="Delete Program"
          subtitle="Are you sure you want to delete program ?"
          description="Program will be deleted permanently and removed from all the programs where it appears."
          record={this.state.record}
          open={this.state.isOpen}
          handleClose={this.handleCloseModalDelete}
        >
          <DeleteButton
            redirect="/programs"
            basePath={this.props.basePath}
            record={this.props.record}
            resource={this.props.resource}
          />
        </DeleteAlertDialog>
      </>
    );
  }
}

export default ToolBarEditProgram;
